module.exports = "pegasus/assets/blocks/column-15-theme6.png";